import {
  BuildingIcon,
  CardIcon,
  ClockIcon,
  FlaskIcon,
  IndicatorLabel,
  RocketIcon,
  UsersIcon,
} from "@codat/orchard-ui";
import { OrchardTheme } from "@codat/orchard-ui/dist/es/ThemeProvider/types"; // eslint-disable-line import/no-unresolved
import { ClientType } from "api/public";
import React from "react";

function getClientTypeBranding(clientType: ClientType):
  | {
      color: keyof OrchardTheme | "interface";
      label: string;
      icon: React.ReactElement;
    }
  | undefined {
  switch (clientType) {
    case "ClientProd":
      return { color: "action", label: "Production", icon: <BuildingIcon /> };
    case "ClientStartUp":
      return { color: "positive", label: "Start-up", icon: <RocketIcon /> };
    case "ClientFreeTrial":
      return { color: "neutral", label: "Free trial", icon: <ClockIcon /> };
    case "ClientProspect":
    case "ClientTest":
    case "ClientTestStartup":
      return { color: "warning", label: "Test", icon: <FlaskIcon /> };
    case "CodatQATest":
      return { color: "interface", label: "QA Test", icon: <FlaskIcon /> };
    case "CodatInternal":
      return {
        color: "interface",
        label: "Codat Internal",
        icon: <UsersIcon />,
      };
    case "CodatSalesDemo":
      return { color: "interface", label: "Sales demo", icon: <CardIcon /> };
    default:
      return undefined;
  }
}

interface ClientTypeLabelProps {
  clientType: ClientType;
}

const ClientTypeLabel = ({ clientType }: ClientTypeLabelProps) => {
  const labelBranding = getClientTypeBranding(clientType);
  if (!clientType || !labelBranding) {
    return <span>Unknown</span>;
  }

  return (
    <IndicatorLabel
      label={labelBranding.label}
      color={labelBranding.color}
      leftIcon={labelBranding.icon}
    />
  );
};

export default ClientTypeLabel;
